import { Box, Typography, Avatar, Paper } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

export interface CrewMember {
  id: number;
  name: string;
  streamsAttended: number;
}

interface LeaderboardCardProps {
  members: CrewMember[];
}

const StreamsLeaderboard = ({ members }: LeaderboardCardProps) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "#ffffff",
        mt: 2,
      }}
    >
      <Box
        sx={{
          bgcolor: "#ffffff",
          px: 2,
          py: 1.5,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            letterSpacing: "0.05em",
            color: "#424242",
            textTransform: "uppercase",
          }}
        >
          Stream Attendance Leaderboard
        </Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        {/* Header Row */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "60px 50px 1fr 100px",
            alignItems: "center",
            px: 1.5,
            py: 1,
            borderBottom: "2px solid #bdbdbd",
            mb: 1,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: "#616161",
              textTransform: "uppercase",
            }}
          >
            Rank
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: "#616161",
              textTransform: "uppercase",
            }}
          ></Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: "#616161",
              textTransform: "uppercase",
            }}
          >
            Crew
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 700,
              color: "#616161",
              textTransform: "uppercase",
              textAlign: "right",
            }}
          >
            Total Streams
          </Typography>
        </Box>
        {/* Data Rows */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {members.map((member, index) => (
            <LeaderboardRow key={member.id} member={member} rank={index + 1} />
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

const LeaderboardRow = ({
  member,
  rank,
}: {
  member: CrewMember;
  rank: number;
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "60px 50px 1fr 100px",
        alignItems: "center",
        borderRadius: 1,
        bgcolor: "#ffffff",
        px: 1.5,
        py: 1,
      }}
    >
      {/* Rank */}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ fontWeight: 700, color: "#757575", fontSize: 16 }}>
          {rank}
        </Typography>
      </Box>

      {/* Avatar */}
      <Avatar
        sx={{
          width: 36,
          height: 36,
          bgcolor: "#9e9e9e",
        }}
      >
        <PersonIcon sx={{ color: "#616161", fontSize: 20 }} />
      </Avatar>

      {/* Crew Name */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: "#424242",
          textTransform: "uppercase",
        }}
      >
        {member.name}
      </Typography>

      {/* Total Streams */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 700,
          color: "#2e7d32",
          textAlign: "right",
        }}
      >
        {member.streamsAttended}
      </Typography>
    </Box>
  );
};
export default StreamsLeaderboard;
